import {
  SET_USER,
  SET_IS_LOGGED,
  LOGOUT,
} from './auth.actions';

const initialState = {
  isAdmin: false,
  isLogged: false,
  user: null,
  company: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_IS_LOGGED:
      return {
        ...state,
        isLogged: payload,
      };
    case SET_USER: {
      return {
        ...state,
        user: payload.user,
        company: payload.company,
        isAdmin: payload.isAdmin,
      }; }
    case LOGOUT:
      return {
        ...state,
        isLogged: false,
      };
    default:
      return state;
  }
};
